import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import '../../Styles/customerForm.css';

class OrderedSupplier extends Component {
	constructor() {
		super();
		this.handlePriority = this.handlePriority.bind(this);
	}
	
	//this.props.id <= supplierConfig.id
	handlePriority(e) {
		e.preventDefault();
		this.props.morePriority(this.props.index, this.props.id);
	}
	
	render() {
//		console.log("OrderedSupplier RENDER");
//		console.log(this.props);
		var userName;
		let separador = (this.props.index>0)?" > ":"";
	return (
			<>
			{separador}
			<span className='orderedsupplier' onClick={this.handlePriority.bind(this)}>
				{this.props.username}
			</span>
			</>
		);
	}
}

export default OrderedSupplier;